import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE } from '../../constants';

const IdentificationCodeTypeService = ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
      method: 'get',
      request: (id, tag, rejectCallback, t) => ({
        url: apiRoutes.communityIdentificationCodeTypes(id, tag),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getIdentificationCodeTypeFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default IdentificationCodeTypeService;
